import { Spinner as ReactSpinner } from 'react-bootstrap'
export default function Spinner() {
  return (
    <ReactSpinner animation='border' role='status'>
      <span className='visually-hidden'>Loading...</span>
    </ReactSpinner>
  )
}
